/**
 * Premium PDP gallery navigation.
 *
 * Dawn's <product-info> + product-form.js handle ALL variant logic, ATC submission,
 * and cart-drawer integration natively. This script only wires the custom gallery
 * (prev/next/thumbnails/swipe) since the rest of Dawn's logic targets a different
 * gallery markup than ours.
 *
 * If you want Dawn-native gallery (with variant image swap auto-wired), swap our
 * gallery markup for {% render 'product-media-gallery' %} in the section file.
 */
(function () {
  if (window.__ppGalleryInit) return;
  window.__ppGalleryInit = true;

  function activateSlide(scope, slide) {
    scope.querySelectorAll('.pp-gallery__slide').forEach((el) =>
      el.classList.toggle('is-active', el === slide)
    );
    const mediaId = slide.dataset.mediaId;
    scope.querySelectorAll('[data-thumb-target]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.thumbTarget === mediaId);
    });
    const current = scope.querySelector('[data-gallery-current]');
    if (current) current.textContent = parseInt(slide.dataset.position, 10) + 1;
  }

  function navGallery(scope, direction) {
    const slides = Array.from(scope.querySelectorAll('.pp-gallery__slide'));
    if (!slides.length) return;
    const idx = slides.findIndex((s) => s.classList.contains('is-active'));
    let next = idx + direction;
    if (next < 0) next = slides.length - 1;
    if (next >= slides.length) next = 0;
    activateSlide(scope, slides[next]);
  }

  function bindGallery(scope) {
    if (scope.__ppGalleryBound) return;
    scope.__ppGalleryBound = true;

    scope.querySelectorAll('[data-thumb-target]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const mediaId = btn.dataset.thumbTarget;
        const slide = scope.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide) activateSlide(scope, slide);
      });
    });

    const prev = scope.querySelector('[data-gallery-prev]');
    const next = scope.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => navGallery(scope, -1));
    if (next) next.addEventListener('click', () => navGallery(scope, 1));

    const stage = scope.querySelector('[data-gallery-stage]');
    if (stage) {
      stage.tabIndex = 0;
      stage.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') navGallery(scope, -1);
        if (e.key === 'ArrowRight') navGallery(scope, 1);
      });
      let startX = 0;
      let dx = 0;
      stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchmove', (e) => { dx = e.touches[0].clientX - startX; }, { passive: true });
      stage.addEventListener('touchend', () => {
        if (Math.abs(dx) > 40) navGallery(scope, dx < 0 ? 1 : -1);
        dx = 0;
      });
    }
  }

  function init() {
    document.querySelectorAll('product-info .pp-gallery, .pk .pp-gallery').forEach(bindGallery);

    // When Dawn's product-info swaps the section HTML on variant change, rebind.
    new MutationObserver(() => {
      document.querySelectorAll('product-info .pp-gallery').forEach(bindGallery);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* ----------------------------------------------------------------------
   * After-ATC destination handling.
   *
   * Section setting `atc_destination` is read from <product-info data-atc-destination>.
   * - 'cart-drawer' → do nothing (let Dawn open the drawer natively)
   * - 'cart-page'   → redirect to /cart after a successful add
   * - 'checkout'    → redirect to /checkout after a successful add
   *
   * We listen for Dawn's PUB_SUB_EVENTS.cartUpdate (fired by product-form.js on a
   * successful /cart/add response) to know when to redirect.
   * ---------------------------------------------------------------------- */
  function setupDestinationRedirect() {
    if (window.__ppAtcDest) return;
    window.__ppAtcDest = true;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      // Only redirect on additions from the product form (not generic cart updates)
      if (!data || data.source !== 'product-form') return;

      const productInfo = document.querySelector('product-info[data-atc-destination]');
      if (!productInfo) return;

      const destination = productInfo.dataset.atcDestination;
      if (destination === 'cart-page') {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } else if (destination === 'checkout') {
        window.location.href = '/checkout';
      }
      // 'cart-drawer' (default) → do nothing — Dawn opens the drawer
    });
  }

  if (document.readyState !== 'loading') setupDestinationRedirect();
  else document.addEventListener('DOMContentLoaded', setupDestinationRedirect);
})();
